module.exports = __webpack_public_path__ + "img/icon_project09.cf755be1.png";